// @flow
import Vue from 'vue'

/**
 * Discussion components tied to code splitting / user chunk
 */
const discussionsCodeSplit = () => {
  Vue.component('discussion-footer', () =>
    import(/* webpackChunkName: "user" */ '@/components/discussions/discussion-footer.vue'),
  )

  Vue.component('discussion-controls', () =>
    import(/* webpackChunkName: "user" */ '@/components/discussions/discussions-controls.vue'),
  )

  Vue.component('discussion-form', () =>
    import(/* webpackChunkName: "user" */ '@/components/discussions/discussion-form.vue'),
  )
}

export default discussionsCodeSplit
